import { useContext, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import i18next from 'i18next';

import { ProductType } from 'types/api/product.type';

import { useAppSelector } from 'redux/hooks';

import { ProductParams, productDataService } from 'services/products.service';

import { CatalogueContext } from 'contexts';

import { useFetch } from 'hooks';

import { checkParams } from 'helpers/checkParams';
import { getSearchParams } from 'helpers/getSearchParams';

import { ListItem } from '../ListItem';

const useQuickOrderModal = () => {
  const { genre, category } = useParams();
  const [searchParams] = useSearchParams();
  const searchParamsData = getSearchParams(searchParams);

  const { season, marketLine, warehouse, zone } = useAppSelector((state) => state.settings);

  const { subProducts, subProductsSet } = useContext(CatalogueContext);

  const { language } = i18next;

  const params: ProductParams = {
    season,
    marketLine,
    genre,
    category,
    warehouse: warehouse.code,
    zone,
    itemCode: searchParamsData.itemCode,
    mainFabricCode: searchParamsData.mainFabricCode,
    itemColorCode: searchParamsData.colorCode,
    styleCodeAndStyleDesc: searchParamsData.styleCodeAndStyleDesc,
    genderCodeAndGenderDesc: searchParamsData.genderCodeAndGenderDesc,
  };

  const { content, isLoading } = useFetch(
    checkParams(params) && subProducts.length === 0
      ? () => productDataService.getSubProducts(params)
      : undefined,
    [season, marketLine, genre, category, searchParamsData, zone, warehouse]
  );

  const productsComponents = subProducts?.map((item: ProductType) => (
    <ListItem
      data={item}
      key={item.id}
      title={item.colorCode}
      desc={language === 'en' ? item.englishColorDescription : item.italianColorDescription}
      asSample={item.colorUsedInSample === 'true'}
      asSubProduct
    />
  ));

  useEffect(() => {
    if (content) {
      subProductsSet(content);
    }
    return () => {
      subProductsSet([]);
    };
  }, [content]);

  return {
    content,
    isLoading,
    productsComponents,
  };
};

export { useQuickOrderModal };
